module.exports = __webpack_public_path__ + "img/bg-payment-help.359a3169.png";